<template>
	<section>

		<!--Last Events-->
		<div class="basic-box cabinet__basic-box">
			<div class="basic-box__title">Последние события</div>

			<!--Basic Box-->
			<div class="basic-box__row-wrap" v-for="event in value">

				<!--Row Item-->
				<div class="basic-box__row hr">
					<div class="basic-box__row-inner">

						<!--Time-->
						<div class="basic-box__row-item basic-box__row-item_time">
							{{ event.time.$date.$numberLong | time('x')}}
						</div>

						<!--Avatar-->
						<div class="basic-box__row-item basic-box__row-item_avatar-wrap">
							<!--<user-avatar :data="event.to" :set-class="'basic-box__avatar'"></user-avatar>-->
						</div>

						<!--Name-->
						<div class="basic-box__row-item basic-box__row-item_name">
							{{generateEventMessage(event)}}
							<!--Воронцов Петр Алексеевич записан к вам на прием 20.09.17-->
						</div>

					</div>
				</div>
				<!--Row Item End-->

			</div>
			<!--Basic Box-->

			<div v-if="!value.length">У Вас еще нет произошедших событий</div>

		</div>
		<!--Last Events End-->

	</section>
</template>

<script>
	import messageGenerator from '../common/messageGenerator.js'
	import UTC from '../common/UTC'
	import moment from 'moment'

	export default {
		name: 'Event',
		props: ['value'],
		computed: {
			isDoctor() {
				return this.$store.state.auth.isDoctor
			}
		},
		data() {
			return {
				count: 5,
				total: 0
			}
		},
		methods: {
			generateEventMessage(event) {
				return messageGenerator.get(event)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Event.vue?51bc8901